import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Acbushireforjejuridarshan() {



const cardData =
{
  keyword: 'AC Bus Hire for Jejuri Darshan',
  heading: 'Sanavi Travels: AC Bus Hire for Jejuri Darshan',
  headingDescription: 'Sanavi Travels offers premium and reliable AC Bus Hire for Jejuri Darshan, providing devotees, families, Warkari groups, corporate teams, wedding guests, and senior citizens with a safe, comfortable, and well-managed travel experience to the sacred town of Jejuri. Jejuri, known as the land of Lord Khandoba, attracts thousands of devotees daily and witnesses massive pilgrim movement during Somvati Amavasya, Champa Shashthi, weekends, and festival days.',

  top: 'Spiritual & Travel Highlights of Jejuri Darshan Journey',

  "topPlaces": [
    {
      "title": "Jejuri Khandoba Temple",
      "description": "The Khandoba Temple at Jejuri is one of Maharashtra’s most revered spiritual destinations. Hiring an AC bus for Jejuri Darshan allows devotees to travel together comfortably, arrive fresh for darshan, and manage group movement efficiently during crowded temple hours. Air-conditioned travel significantly reduces fatigue, especially for elders and children."
    },
    {
      "title": "Somvati Amavasya Darshan Travel",
      "description": "Somvati Amavasya attracts massive crowds to Jejuri. AC bus hire helps groups travel safely, avoid multiple vehicles, and maintain discipline during peak pilgrimage traffic."
    },
    {
      "title": "Champa Shashthi Festival Trips",
      "description": "During Champa Shashthi, Jejuri experiences heavy footfall. AC buses provide relief from heat and crowd stress, ensuring a smooth and comfortable devotional journey."
    },
    {
      "title": "Family Darshan Tours",
      "description": "Families visiting Jejuri prefer AC buses for better comfort, controlled temperature, safe seating, and relaxed travel for all age groups."
    },
    {
      "title": "Senior Citizen Temple Visits",
      "description": "Senior devotees benefit greatly from AC bus travel due to reduced exhaustion, smooth rides, and professional drivers familiar with temple access routes."
    },
    {
      "title": "Group & Community Yatras",
      "description": "Community groups, bhajan mandals, and religious trusts use AC buses to travel together, sing bhajans, and maintain spiritual harmony during the journey."
    },
    {
      "title": "Wedding & Ritual Temple Visits",
      "description": "Many families visit Jejuri for pre-wedding rituals and blessings. AC bus hire ensures elegant and comfortable group transportation."
    },
    {
      "title": "Corporate Spiritual Outings",
      "description": "Companies organize spiritual trips to Jejuri for employees. AC bus travel ensures professional, punctual, and organized transportation."
    },
    {
      "title": "One-Day & Overnight Jejuri Trips",
      "description": "AC buses support both one-day darshan plans and overnight stays, offering flexible scheduling and safe return travel."
    },
    {
      "title": "Peaceful & Hassle-Free Travel",
      "description": "With experienced drivers managing traffic and navigation, devotees can focus entirely on prayers and spiritual preparation."
    }
  ],

  "services": [
    {
      "name": "AC Bus Hire for Jejuri Darshan",
      "description": "Sanavi Travels provides specialized AC bus hire services for Jejuri Darshan, designed for devotees seeking comfort, safety, and disciplined group travel. The service includes clean air-conditioned buses, experienced drivers, route planning, flexible pickup points, and smooth coordination for darshan schedules. Ideal for families, Warkari groups, corporate outings, and large pilgrim groups, this service ensures a peaceful and comfortable religious journey."
    },
    {
      "name": "Luxury AC Bus Rental Jejuri",
      "description": "Luxury AC buses feature premium interiors, pushback seats, superior suspension, and enhanced comfort, making them ideal for VIP devotees, corporate groups, and wedding parties visiting Jejuri."
    },
    {
      "name": "32 Seater AC Bus Hire Jejuri",
      "description": "32 seater AC buses are perfect for medium-sized groups, offering balanced seating capacity, climate comfort, and smooth long-distance travel."
    },
    {
      "name": "35 Seater AC Bus Rental Jejuri",
      "description": "35 seater AC buses are suitable for large pilgrimage groups, community yatras, and festival travel to Jejuri."
    },
    {
      "name": "AC Bus for Family Jejuri",
      "description": "Family-focused AC bus services ensure safe, comfortable, and stress-free travel for children, elders, and adults."
    },
    {
      "name": "AC Bus for Corporate Jejuri",
      "description": "Corporate AC bus services support organized spiritual trips, team outings, and employee religious tours with professional travel management."
    },
    {
      "name": "AC Bus for Group Jejuri",
      "description": "Group AC buses allow all passengers to travel together, avoiding coordination issues and ensuring punctual darshan."
    },
    {
      "name": "Mini AC Bus Hire Jejuri",
      "description": "Mini AC buses are ideal for small groups and families seeking flexible and comfortable Jejuri Darshan travel."
    },
    {
      "name": "AC Bus for Wedding Jejuri",
      "description": "Wedding-related temple visits are handled smoothly with AC buses that provide elegance, comfort, and group coordination."
    },
    {
      "name": "Affordable AC Bus Rental Jejuri",
      "description": "Affordable AC bus packages offer cost-effective solutions without compromising comfort, safety, or service quality."
    },
    {
      "name": "Best AC Bus Service Jejuri",
      "description": "Sanavi Travels is trusted as one of the best AC bus service providers for Jejuri Darshan, known for reliability and comfort."
    },
    {
      "name": "AC Bus with Driver Jejuri",
      "description": "All AC bus rentals include trained drivers experienced in Jejuri routes, temple parking, and pilgrimage traffic management."
    },
    {
      "name": "AC Bus for Picnic Jejuri",
      "description": "Picnic-style religious tours to Jejuri are comfortable and enjoyable with air-conditioned bus travel."
    },
    {
      "name": "AC Bus for Outstation Jejuri",
      "description": "Outstation AC bus services ensure smooth highway travel, planned breaks, and relaxed journeys."
    },
    {
      "name": "AC Bus for Jejuri Tour Packages",
      "description": "Customized AC bus tour packages support combined temple visits, sightseeing, and group travel plans."
    }
  ],

  "tableData": [
    ["AC Bus Jejuri Darshan", "Luxury AC Bus"],
    ["32 Seater AC Bus", "35 Seater AC Bus"],
    ["Mini AC Bus", "Group Travel"],
    ["Family Trip", "Corporate Trip"],
    ["Wedding Travel", "Outstation Travel"]
  ],

  "whychoose": [
    { "WhyChooseheading": "Comfortable AC Travel", "WhyChoosedescription": "Air-conditioned buses reduce fatigue during temple travel." },
    { "WhyChooseheading": "Experienced Temple Route Drivers", "WhyChoosedescription": "Drivers know Jejuri traffic and darshan patterns." },
    { "WhyChooseheading": "Clean & Sanitized Vehicles", "WhyChoosedescription": "Regular cleaning ensures hygiene and safety." },
    { "WhyChooseheading": "Flexible Pickup Locations", "WhyChoosedescription": "Pickup points customized as per group needs." },
    { "WhyChooseheading": "Multiple Bus Options", "WhyChoosedescription": "Mini, 32 seater, and 35 seater AC buses available." },
    { "WhyChooseheading": "Affordable Transparent Pricing", "WhyChoosedescription": "No hidden charges in pricing." },
    { "WhyChooseheading": "Group Coordination", "WhyChoosedescription": "Entire group travels together comfortably." },
    { "WhyChooseheading": "Trusted Darshan Partner", "WhyChoosedescription": "Sanavi Travels is trusted for Jejuri Darshan travel." }
  ]
};

const faqData = [
  { question: 'Do you provide AC buses for Jejuri Darshan?', answer: 'Yes, Sanavi Travels provides AC bus rental services for Jejuri Darshan.' },
  { question: 'Are luxury AC buses available?', answer: 'Yes, luxury AC buses are available for premium travel.' },
  { question: 'Is this service suitable for senior citizens?', answer: 'Yes, AC buses are comfortable and ideal for elderly devotees.' },
  { question: 'Can we book buses for Somvati Amavasya?', answer: 'Yes, we provide AC buses for Somvati Amavasya darshan.' },
  { question: 'Do you offer one-day Jejuri trips?', answer: 'Yes, one-day and overnight Jejuri trips are supported.' },
  { question: 'Is driver included in the booking?', answer: 'Yes, all AC bus rentals include experienced drivers.' },
  { question: 'What seating options are available?', answer: 'Mini AC buses, 32 seater, and 35 seater AC buses are available.' },
  { question: 'Are buses cleaned before travel?', answer: 'Yes, all buses are cleaned and sanitized before every trip.' },
  { question: 'Can pickup points be customized?', answer: 'Yes, pickup locations can be customized.' },
  { question: 'Is this an outstation service?', answer: 'Yes, Jejuri Darshan is handled as an outstation bus service.' }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ramesh Kale',
    feedback: 'Very comfortable AC bus journey for Jejuri Darshan. Excellent service and timing.',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Seema Deshmukh',
    feedback: 'Best AC bus service for Jejuri. Clean bus and professional driver.',
    rating: 5
  }
];



































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];





const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "AC Bus Hire for Jejuri Darshan - Sanavi Travels",
  "description": "Sanavi Travels offers AC bus hire for Jejuri Darshan for family trips, corporate travel, group tours, weddings, picnics, outstation trips, and tour packages. Luxury AC buses, mini buses, 32-seater and 35-seater options are available with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};











  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | AC Bus Hire for Jejuri Darshan | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book AC bus hire for Jejuri Darshan with Sanavi Travels. Luxury AC buses, mini buses, 32-seater and 35-seater options for family trips, corporate travel, group tours, weddings, picnics, outstation trips, and tour packages with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/268.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Acbushireforjejuridarshan;